import React, { memo } from 'react';
import { Wrapper, Title, Subheader, Supheader } from './components';
import { purify } from '../../utils/helpers';
function Header({ text, supheader = '', subheader = '', textAlign = 'center', disableEndMargin = false, }) {
    return (React.createElement(Wrapper, { textAlign: textAlign, disableEndMargin: disableEndMargin },
        supheader && React.createElement(Supheader, null, supheader),
        React.createElement(Title, { dangerouslySetInnerHTML: { __html: purify(text) } }),
        subheader && React.createElement(Subheader, null, subheader)));
}
export default memo(Header);
//# sourceMappingURL=header.js.map